'use strict';

angular.module('chatEngine.directives', [
    'chatEngine.configuration',
    'chatEngine.services',
    'chatEngine.resources',
    'chatEngine.loadingDialog'
])

.directive('ngEnter', function() {
    return {
        restrict: 'A',
        link: function(scope, elements, attrs) {
            elements.bind('keydown keypress', function(event) {
              if (event.which === 13) {
                  scope.$apply(function() {
                      scope.$eval(attrs.ngEnter);
                  });
                  event.preventDefault();
              }
          });
        }
    };
})

.directive('autofocus', ['$timeout', function($timeout) {
    return {
        restrict: 'A',
        link: function($scope, $el) {
            $timeout(function() {
                $el[0].focus();
            });
        }
    };
}])

/**
 * Watches the value of `focus-me` attribute. If it changes to true, focus the element.
 */
.directive('focusMe', function() {
    return {
        restrict: 'A',
        link: function($scope, $el, $attr) {
            var trigger = $attr.focusMe;
            if(!trigger) {
                throw new Error('focus-me must have a valid watch variable');
            }
            function watchFn(value) {
                if(value === true) {
                    $scope.$applyAsync(function() {
                        $el.focus();
                    });
                }
            }
            $scope.$watch(trigger, watchFn);
        }
    };
})

.directive('activateEngine', ['Engine', 'Dialog', 'LoadingDialog', function(Engine, Dialog, LoadingDialog) {
    return {
        restrict: 'AE',
        templateUrl: 'views/activate-engine.html',
        scope: {
            engineData: '=',
            canActivateFunc: '='
        },
        link: function($scope) {
            $scope.engineData = $scope.engineData || null;

            $scope.isDefaultEngine = function() {
                return $scope.engineData !== null && $scope.engineData.default === true;
            };

            $scope.activate = function(engineData) {
                if($scope.canActivateFunc(engineData)) {
                    var defaultEngine = Engine.getDefaultEngine();
                    if (defaultEngine !== null) {
                        var defaultMeta = Engine.getMetaByType(defaultEngine.type);
                        Dialog.confirm('Are you sure?', 'This will deactivate the ' + defaultMeta.title +
                        ' and all future messages will be delivered to this engine.')
                            .result.then(function() {
                                setDefault(engineData.id);
                            }
                        );
                    } else {
                        setDefault(engineData.id);
                    }
                } else {
                    var engineMeta = Engine.getMetaByType(engineData.type);
                    Dialog.alert('Please configure', engineMeta.configureDescription);
                }
            };

            function setDefault(id) {
                var loadingDialog = LoadingDialog.show('Activating engine, please wait...');
                Engine.setDefault({id: id}, $scope.engineData, function(engineData) {
                    LoadingDialog.hide(loadingDialog).then(function() {
                        $scope.engineData = engineData;
                        var engineMeta = Engine.getMetaById(engineData.id);
                        Dialog.alert('Success!', 'The ' + engineMeta.title + ' has successfully been activated.');
                    });
                }, function() {
                    LoadingDialog.hide(loadingDialog).then(function() {
                        Dialog.alert('Error', 'Something went wrong while activating your engine, ' +
                        'please try again later.');
                    });
                });
            }
        }
    };
}])

.directive('enginesBreadcrumbs', function() {
    return {
        restrict: 'AE',
        templateUrl: 'views/engines-breadcrumbs.html',
        scope: {
            engineMeta: '='
        }
    };
})

.directive('engineTemplate', ['Engine', '$routeParams', 'Dialog', function(Engine, $routeParams, Dialog) {
    return {
        restrict: 'AE',
        template: '<div ng-include="engineUrl"></div>',
        link: function($scope) {
            Engine.query(function(engines) {
                Engine.setData(engines);
                var engineData = Engine.getDataById($routeParams.id);
                if(engineData !== null) {
                    $scope.engineUrl = 'views/' + engineData.type + '-engine.html';
                } else {
                    engineError();
                }
            }, engineError);

            function engineError() {
                $scope.loadingError = true; // do not show loading spinner anymore
                Dialog.alert('Error', 'Something went wrong while fetching your engine, please try again later.');
            }
        }
    };
}])

.directive('loadingSpinner', function() {
    return {
        restrict: 'AE',
        templateUrl: 'views/loading-spinner.html'
    };
})

.directive('banner', function() {
    return {
        restrict: 'E',
        templateUrl: 'views/banner.html',
        scope: {
            callback: '&callback',
            delete: '&delete',
            image: '=image',
            width: '@width',
            height: '@height',
            loading: '=loading'
        },
        link: function($scope, el) {
            // Forcing the aspect ratio
            var stretcherElement = angular.element('.banner-box', el);
            stretcherElement.css('padding-bottom', (100 * $scope.height / $scope.width) + '%');

            // Creating a file element which will handle the file selection and calling the callback
            var fileElement = angular.element('<input />')
                .attr('type', 'file')
                .attr('accept', 'image/png,image/jpeg')
                .addClass('hide')
                .bind('change', function() {
                    $scope.callback()(fileElement.get(0).files[0]);
                    fileElement.val(null);
                })
                .appendTo(el);

            var deleteElement = angular.element('.banner-delete-button', el);

            $scope.browse = function() {
                fileElement.click();
            };

            $scope.deleteBanner = function($event) {
                // The delete button is placed within the main container, so we need to stop the event propagation in
                // order to avoid triggering browse()
                $event.stopPropagation();

                $scope.delete()();
            };
        }
    };
})

/**
 * Generates money value from the model
 * money value must always be null or integer cents
 * use ng-trim="false" to auto-trim spaces from input
 * @param money variable to store parsed money value into
 * @param moneyMax maximum amount (in cents) to allow input for
 * @param moneyAllowNegative set to 'true' to allow negative monetary values
 */
.directive('money', function() {
    return {
        restrict: 'A',
        scope: {
            money: '=',
            max: '=moneyMax',
            model: '=ngModel',
            allowNeg: '@moneyAllowNegative'
        },
        link: function($scope) {
            var max = 9e15; // maximum safe integer value is Number.MAX_SAFE_INTEGER = 2^53-1 ~ 9e15
            var allowNeg = false;
            // returns false for invalid value, null for intermediate value, or an integer for valid values
            function parseMoney(value) {
                var split = value.split('.');
                var dollars = split[0];
                var cents = split[1];
                var money = 0;
                var isNeg = false;

                // handle case of intermediate values
                if (value.length === 0 || value === '.' || value === '-') {
                    return null;
                }
                // handle case of too many periods
                if (split.length > 2) {
                    return false;
                }

                if (dollars.charAt(0) === '-') {
                    if (allowNeg === true) {
                        dollars = dollars.slice(1);
                        isNeg = true;
                    } else {
                        return false;
                    }
                }

                if (/^\d*$/.test(dollars)) {
                    money += 100 * dollars;
                } else {
                    return false;
                }

                if (cents) {
                    if (/^\d{1,2}$/.test(cents)) {
                        if (cents.length === 1) {
                            money += 10 * cents;
                        } else {
                            money += (+cents);
                        }
                    } else {
                        return false;
                    }
                }

                if (money > max) {
                    return false;
                }

                if (isNeg) {
                    return money * -1;
                }

                return money;
            }
            $scope.$watch('max', function(newValue) {
                newValue = +newValue;
                if(!isNaN(newValue)) {
                    max = newValue;
                }
            });
            $scope.$watch('allowNeg', function(newValue) {
                allowNeg = newValue === 'true';

                if(allowNeg === false && typeof $scope.model === 'string' && $scope.model.charAt(0) === '-') {
                    $scope.model = $scope.model.slice(1);
                }
            });
            $scope.$watch('model', function(newValue, oldValue) {
                newValue = String(newValue).trim();
                var money = parseMoney(newValue);
                if(money === false) {
                    if(newValue === oldValue || typeof oldValue !== 'string') {
                        // initial value was invalid; reset model
                        $scope.model = '';
                    } else {
                        $scope.model = oldValue;
                    }
                } else {
                    $scope.model = newValue;
                    $scope.money = money;
                }
            });
        }
    };
})

/**
 * UI component for a group of radio buttons, where each radio can enable a nested checklist
 * Parameters are passed in as targetList
 * name - title of list
 * value - default selected radio button
 * options - array of radio buttons
 *  name - label for each radio button
 *  value - value of radio button (targetList.value equals this if this radio is selected)
 *  options - array of nested checkboxes
 *      name - label of checkbox
 *      checked - set to true iff checkbox is checked
 * Note: all value parameters must be strings
 */
.directive('targetingChecklist', function() {
    return {
        restrict: 'C',
        scope: {
            targetList: '=targetList'
        },
        templateUrl: 'views/targeting-checklist.html',
        link: function($scope) {
            // makes sure the spec is valid
            function _validateValue(value) {
                if(typeof value !== 'string') {
                    console.error(value + ' is not a string, this will cause undefined behaviour.',
                        'Spec:', $scope.targetList);
                }
            }
            $scope.$watch('targetList', function(subject) {
                _validateValue(subject.value);
                angular.forEach(subject.options, function(option) {
                    _validateValue(option.value);
                });
            }, true);
        }
    };
})

/**
 * UI component for a select
 * Parameters are passed in as targetList
 * name - title of list
 * value - default selected radio button
 * options - array of name/value pairs
 *  name - label for option
 *  value - value of button (targetList.value equals this if this option is selected)
 * Note: all value parameters must be strings
 */
.directive('targetingDropdown', function() {
    return {
        restrict: 'C',
        scope: {
            targetList: '=targetList'
        },
        templateUrl: 'views/targeting-dropdown.html',
        link: function($scope) {
            // makes sure the spec is valid
            function _validateValue(value) {
                if(typeof value !== 'string') {
                    console.error(value + ' is not a string, this will cause undefined behaviour.',
                        'Spec:', $scope.targetList);
                }
            }
            $scope.$watch('targetList', function(subject) {
                _validateValue(subject.value);
                angular.forEach(subject.options, function(option) {
                    _validateValue(option.value);
                });
            }, true);
        }
    };
})

/*
 * Message Editor responsible for displaying and validating components
 * for editing messages sent by a bot.
 * Handles uploading and checking images and validating messages by each message type
 * Params:
 *  msg - message to be edited or set
 *  isValid - the scope function name you want to use as the validator (ie so you can enable/disable buttons using
 *  ng-disabled="<isValid>()")
 */
.directive('msgEditor', ['URL_REGEX', '$window', '$timeout', 'Dialog', 'imageUploadService', 'sessionDataService',
    function(URL_REGEX, $window, $timeout, Dialog, imageUploadService, sessionDataService) {
    return {
        restrict: 'E',
        templateUrl: 'views/msg-editor.html',
        scope: {
            message: '=msg',
            validForm: '=isValid'
        },
        link: function($scope) {
            var JSON_DATA_LIMIT = 30000;
            var URL_LIMIT = 16000;
            var MAX_FILE_SIZE = 10000000;

            $scope.maxLength = 140;
            $scope.showImageLoader = false;

            $scope.message_types = [
                {type: 'text', display: 'None'},
                {type: 'gallery', display: 'Image'},
                {type: 'plain-web', display: 'Link'}
            ];

            configureMessageTypes();

            //For the case where get config takes a while
            $scope.$on('sessionDataUpdated', function() {
                configureMessageTypes();
            });

            function configureMessageTypes() {
                var data = sessionDataService.getCurrentBotData();
                if (data && data.kow_url && $scope.message_types.length < 4) {
                    $scope.message_types.push({type: 'kik-optimized-web', display: 'Kik Optimized Website'});
                }
            }

            $scope.browseImage = function() {
                // $timeout forces changes to apply, otherwise Angular complains because
                // we programatically triggered the click
                $timeout(function() {
                    angular.element('#file-input-image').click();
                });
            };

            $scope.onFileInputChange = function(el) {
                var chosenFile = el.files[0];
                el.value = null;

                $scope.showImageLoader = true;
                imageUploadService.upload(chosenFile)
                .then(function(data) {
                    if ($scope.message.type === 'gallery') {
                        $scope.message.picUrl = data.url;
                    } else if($scope.message.type === 'kik-optimized-web') {
                        $scope.message.kowPicUrl = data.url;
                    }
                    $timeout(function() {
                        $scope.showImageLoader = false;
                    }, 500);
                }, function(error) {
                    Dialog.alert('Error', error.message);
                    $scope.showImageLoader = false;
                });
            };

            $scope.validForm = function() {
                if ($scope.showImageLoader) {
                    return false;
                }
                if (typeof($scope.message.body) === 'string' && $scope.message.body.length > $scope.maxLength) {
                    return false;
                }
                if ($scope.message.type === 'text' && !isValidText()) {
                    return false;
                } else if ($scope.message.type === 'gallery' && !isValidGallery()) {
                    return false;
                } else if ($scope.message.type === 'plain-web' && !$scope.isValidURL()) {
                    return false;
                } else if ($scope.message.type === 'kik-optimized-web' &&
                    (!$scope.isValidJSON() || !isValidContent())) {
                    return false;
                }
                return true;
            };

            function isValidText() {
                if (!$scope.message.body || $scope.message.body.length > $scope.maxLength) {
                    return false;
                }
                return true;
            }

            function isValidGallery() {
                if (!$scope.message.picUrl) {
                    return false;
                }
                return true;
            }

            $scope.isValidURL = function() {
                return URL_REGEX.test($scope.message.url) && $scope.message.url.length < URL_LIMIT;
            };

            function isValidContent() {
                if ($scope.message.big === true && $scope.message.picUrl) {
                    return true;
                } else if ($scope.message.big === true && $scope.message.kowPicUrl) {
                    return true;
                } else if (!$scope.message.big &&
                    ($scope.message.title && $scope.message.title.length <= $scope.maxLength) &&
                    ($scope.message.text && $scope.message.text.length <= $scope.maxLength)) {

                    return true;
                }
                return false;
            }

            $scope.isValidJSON = function() {
                if (typeof($scope.message.data) === 'string' &&
                    ($scope.message.data.length > JSON_DATA_LIMIT)) {

                    return false;
                }

                if (!$scope.message.data) {
                    $scope.message.data = null;
                }

                try {
                    JSON.parse($scope.message.data);
                } catch (err) {
                    return false;
                }
                return true;
            };
        }
    };
}])

/*
 * Message tester directive. Displays ui elements needed to send test messages and handles sending of messages.
 * Params:
 *  validForm: a validator function used to enable or disable the Send Test button (ideally same as msgEditor isValid)
 *  msg: the test message to be sent
 */
.directive('msgTester', ['$http', 'Dialog', 'LoadingDialog', 'messageService', 'sessionDataService',
    function($http, Dialog, LoadingDialog, messageService, sessionDataService) {
    return {
        restrict: 'E',
        templateUrl: 'views/msg-tester.html',
        scope: {
            validForm: '=isValid',
            message: '&msg'
        },
        link: function($scope) {
            var USERNAME_REGEX = /^[\w.]{2,30}$/;

            $scope.username = sessionStorage.msgTesterUsername || sessionDataService.getKikUsername();

            $scope.validUsername = function() {
                if (!$scope.username) {
                    return false;
                }
                return USERNAME_REGEX.test($scope.username);
            };

            $scope.testMessage = function() {
                sessionStorage.msgTesterUsername = $scope.username;

                var messages = messageService.messageToArray($scope.message());
                for(var i = 0 ; i < messages.length ; i++) {
                    messages[i].to = $scope.username;
                }

                var loadingDialog = LoadingDialog.show('Setting up test message...');
                $http.post('/api/v1/sample_message', {'messages': messages})
                .success(function() {
                    LoadingDialog.hide(loadingDialog).then(function() {
                        Dialog.alert(
                            'Success!',
                            'Your message has been sent successfully. ' +
                            'Please be patient as this may take a few minutes.'
                        );
                        $scope.disableSend = false;
                    });
                })
                .error(function() {
                    LoadingDialog.hide(loadingDialog).then(testMessageError);
                });

                function testMessageError() {
                    Dialog.alert('Error', 'An error has occurred, please try again.');
                    $scope.disableSend = false;
                }
            };
        }
    };
}])

.directive('imageonload', function() {
    return {
        restrict: 'A',
        scope: {
            imageonload: '@',
            loader: '='
        },
        link: function(scope, element, attrs) {
            attrs.$observe('imageonload', function(data) {
                if (!data) {
                    return;
                }
                scope.loader = true;

                var image = new Image();
                image.src = attrs.imageonload;
                image.onload = animateOut;
                image.onerror = animateOut;
            });

            function animateOut() {
                scope.$apply(function() {
                    scope.loader = false;
                });
            }
        }
    };
})

.directive('errSrc', function() {
    // http://stackoverflow.com/q/16310298/368772
    return {
        link: function(scope, element, attrs) {
            element.bind('error', function() {
                if (attrs.src !== attrs.errSrc) {
                    attrs.$set('src', attrs.errSrc);
                }
            });
        }
    };
})

.directive('renderdocs', ['$compile', '$routeParams', '$timeout', '$window',
function($compile, $routeParams, $timeout, $window) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var urlEventMap = {
                'https://botsupport.kik.com/hc/en-us': 'Bot Support Click',
                'https://www.kik.com/blog/category/bots/': 'Bots Blog Click'
            };
            scope.$on('$destroy', function() {
                $timeout(function() {
                    // Unfortunately, scrollspy does not provide a function to be destroyed
                    $('body').off('scroll.bs.scroll-spy.data-api');
                    $('body').removeData('bs.scrollspy');
                    $('li.sidenav.sub-section.active').removeClass('active');
                }, 100);
            });
            attrs.$observe('renderdocs', function(data) {
                if (data === 'true') {
                    // Highlights all the code blocks
                    $('pre code').each(function(i, block) {
                        hljs.highlightBlock(block);
                    });
                    var links = element[0].getElementsByTagName('a');
                    for (var i = 0; i < links.length; i++) {
                        var link = links[i];
                        var href = link.getAttribute('href');
                        if (link.hostname !== $window.location.hostname) {
                            // Making links that point to another domain popups
                            link.setAttribute('target', '_blank');

                            var eventName = urlEventMap[href];

                            if (eventName && eventName.length > 0 && !link.getAttribute('ng-click')) {
                                var linkClass = link.getAttribute('class');
                                var isSideBarLink = linkClass && linkClass.indexOf('sidebar-link') !== -1;

                                var linkSource = isSideBarLink ? 'sidebar' : (
                                    $routeParams.file.replace(/-/g, ' ') + ' page'
                                );

                                link.setAttribute(
                                    'ng-click',
                                    'externalLink(\'' + eventName + '\',\'' + linkSource + '\')'
                                );
                                $compile(link)(scope);
                            }
                        } else if (document.getElementById(href.slice(1)) && !link.getAttribute('ng-click')) {
                            // Add ng-click to other anchor links
                            link.setAttribute(
                                'href',
                                '/#/docs/' + $routeParams.file + href
                            );
                            link.setAttribute(
                                'ng-click',
                                '$event.preventDefault(); goTo(\'' + $routeParams.file + '\',\'' + href.slice(1) + '\')'
                            );
                            $compile(link)(scope);
                        }
                    }

                    // Keeping the menu highlight up to date.
                    $timeout(function() {
                        $('body').scrollspy({
                            target: '#sidebar',
                            offset: 120
                        });
                    }, 100);

                    $('html, body').scrollTop(0);
                }
            });
        }
    };
}])

.directive('scrollto', ['$location', '$timeout', '$routeParams', function($location, $timeout, $routeParams) {
    return {
        restrict: 'A',
        link: function(scope) {
            scope.goTo = function(file, anchor) {
                var currentAnchor = $location.hash();
                if ($routeParams.file !== file) {
                    $location.path('/docs/' + file);
                }

                if (anchor && currentAnchor === anchor) {
                    var target = $('#' + anchor);
                    if (target.length) {
                        $timeout(function() {
                            $('html, body').scrollTop(target.position().top - 50);
                        });
                    }
                } else {
                    $location.hash(anchor);
                }
            };

            scope.$on('goTo', function(event, data) {
                scope.goTo(data.file, data.anchor);
            });

            scope.$watch(function() {
                return $location.hash();
            }, function(value) {
                if (value) {
                    var target = $('#' + value);
                    if (target.length) {
                        $timeout(function() {
                            $('html, body').scrollTop(target.position().top - 50);
                        });
                    }
                } else {
                    $timeout(function() {
                        $('html, body').scrollTop(0);
                    });
                }
            });
        }
    };
}]);
